module.exports = {
          srcSet: __webpack_public_path__ + "50d3868eb08a2fdddf9abd7611873147-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "50d3868eb08a2fdddf9abd7611873147-79.png",width: 79,height: 79}],
          src: __webpack_public_path__ + "50d3868eb08a2fdddf9abd7611873147-79.png",
          toString:function(){return __webpack_public_path__ + "50d3868eb08a2fdddf9abd7611873147-79.png"},
          
          width: 79,
          height: 79
        }